
import React from 'react';

interface IconProps {
  size?: number;
}

const JavaIcon: React.FC<IconProps> = ({ size = 24 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size}>
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-1.05 18.33c-1.89.96-4.02.81-5.64-.42-1.62-1.23-2.19-3.3-1.44-5.19.75-1.89 2.58-3.03 4.59-2.73 2.01.3 3.63 1.83 4.23 3.78l-1.92.63c-.45-1.32-1.62-2.25-3-2.4-1.38-.15-2.76.6-3.36 1.86-.6 1.26-.33 2.82.69 3.75.99.93 2.52 1.05 3.78.3l1.11 1.62z" fill="#007396"/>
    </svg>
  );
};

export default JavaIcon;
